import React,{useEffect} from 'react'
import Header from '../Header/Header'
import Welcome from '../Welcome/Welcome'
import ArticleSec from '../ArticleSec/ArticleSec'
import Map from '../Map/Map'
import { GA_VPush } from "../Services/GoogleAnalytics";
import Fight from '../Fight/Fight.jsx';

export default function MainPage() {
    let analArr = ["ראשי" , "מפת ההר" , "האירועים על ההר","חצי שעה ששינתה את המזרח התיכון" ,
                   " אנשי הר הבית" , "הסוויץ האמוני","פן ארכיאולוגי"]
    let counter = -1
    //VPush Observer
    useEffect(() => {
        //Sets the Observer options
        const options = {
          root: null, // The view port
          threshhold: 0.5, // 0 ~ 1
          rootMargin: "0px", // like margin in css
        };
        const observer = new IntersectionObserver(function (entries, observer) {
          entries.forEach((entry) => {
            if (!entry.isIntersecting)return;
            counter++
            // console.log("@@@@@@@@@@@@@@@@@@@@@@@    " , counter)
            const title = "הר המריבה - " + analArr[counter];
            GA_VPush( `${title}` , `/templemount/${title}` )
            // console.log(`/templemount/${title}` , `${title}`)
            observer.unobserve(entry.target);
            })
        }, options);
        const wantedNodes = document.querySelectorAll(".watch");
        wantedNodes.forEach((li) => {
          observer.observe(li);
        });
      }, []);

    // Header color intersection observer
    useEffect(() => {
        //Sets the Observer options
        const options = {
          root: null, // The view port
          threshhold: 0.5, // 0 ~ 1
          rootMargin: "0px", // like margin in css
        };
        const observer = new IntersectionObserver(function (entries, observer) {
          let header = document.querySelector(".header")
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                header.style.backgroundColor = "#00000080"
            }else{
                header.style.backgroundColor = "transparent"
            }
            })
        }, options);
        const wantedNodes = document.querySelectorAll(".watch_header");
        wantedNodes.forEach((li) => {
          observer.observe(li);
        });
      }, []);

    return (
        <>
            <Welcome />
            <Map />
            <Fight />
            <ArticleSec />
        </>
    )
}
